import CarbonSummedContainer from './CarbonSummedContainer';

export default CarbonSummedContainer;
